import { styled as muiStyled } from '@mui/material/styles'
import PropTypes from 'prop-types'

import breakpoints from '../../../lib/Breakpoints'

const StyledCard = muiStyled('span')(({ theme }) => ({
  background: theme.palette.common.white,
  width: '50%',
  minHeight: '100px',
  boxShadow: '0 2px 14px 0 rgba(0, 0, 0, 0.1)',
  padding: '20px',
  [`@media (max-width: ${breakpoints.tablet})`]: {
    width: '90%',
  },
}))

const Card = ({ className, children }) => {
  return <StyledCard className={className}>{children}</StyledCard>
}

Card.propTypes = {
  children: PropTypes.any,
  className: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
}

export default Card
